
/*
* komponen ini menggunakan material tailwind, jika ingin mengubah atau menambah
* lihat halaman ini sebagai referensi
* https://www.material-tailwind.com/docs/react/installation
*
*/

import { RootContext } from '../../../App';
import axiosInstance from '../../../config/axios';
import refactorStructureData from '../../../helpers/refactorDataMenu';
import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import Input from "@material-tailwind/react/Input";
import Button from "@material-tailwind/react/Button";
import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import Image from "@material-tailwind/react/Image";
import { Textarea } from '@material-tailwind/react';

export default function AmpConfig() {

    const [listData, setListData] = useState();
    const [newData, setNewData] = useState([]);
    const { state, setState } = useContext(RootContext);
    const history = useHistory();
    const [saving, setSaving] = useState();
    const group = JSON.parse(localStorage.getItem("group"));

    const [ampLogo, setAmpLogo] = useState();
    const [ampLogin, setAmpLogin] = useState();
    const [ampRegister, setAmpRegister] = useState();
    const [linkAlternative, setLinkALternative] = useState();

    const handleChangeImage = () => {

        history.push('/web_management/cms/update_amp_logo');
    }

    const handleSave = () => {

        const token = localStorage.getItem("access_token");

        if (!token) {

            /* history.push("/login");
            console.log('Not Valid Token'); */

        } else {

            try {

                const data = {
                    token : token,
                    group : group.wbid,

                    ampLogin          : ampLogin,
                    ampRegister       : ampRegister,
                    linkAlternative   : linkAlternative,
                }

                axiosInstance('update_amp_config', {

                    method: "POST",

                    data: data,

                }).then((res) => {

                    localStorage.setItem("access_token", res.data.data.token);

                    if(res.data.code === 0) {

                        Swal.fire(
                            'Saved',
                            'Data Saved',
                            'success',
                        );

                        setSaving(false);
                    }else{

                        Swal.fire(
                            'Failed',
                            'Failed To save',
                            'error',
                        );

                        setSaving(false);
                        console.log('Error Mesage: '+res.data.message);
                    }

                }).catch((err) => {

                    let errstatus = err.response.status;
    
                    let errmesage = err.response.data.message;
        
                    if(errstatus === 401){
        
                        Swal.fire(
                            'Expire Token',
                            'Your Token Has Expire',
                            'warning'
                        ).then(() => {
        
                            console.log("Token Expire 401");
                            localStorage.removeItem("access_token");
        
                            history.push("/login");
                        });
        
                    }else{
        
                        Swal.fire(
                            'Warning',
                            errmesage,
                            'warning'
                        ).then(() => {
        
                            setSaving(false);
        
                        })
                    }

                });

            } catch (error) {

                Swal.fire(
                    'Warning',
                    error,
                    'warning'
                ).then(() => {

                    setSaving(false);

                })

            }

        }
    }

    const getData = () => {

        const token = localStorage.getItem("access_token");

        const data = {

            token: token,
            group: group.wbid,
        }

        if (!token) {

            history.push("/login");
            console.log('Not Valid Token');

        } else {

            try {

                axiosInstance('get_amp_config', {

                    method: "POST",

                    data,

                }).then((res) => {

                    const data = res.data.data.list;

                    localStorage.setItem("access_token", res.data.data.token);

                    setListData(data);

                    setNewData({...newData, token: res.data.data.token, group: group.wbid})

                    setState({

                        ...state,

                        group: res.data.data.additional_data.group,

                        menu: refactorStructureData(res.data.data.additional_data.menu),

                    });

                }).catch((err) => {

                    let errstatus = err.response.status;
    
                    let errmesage = err.response.data.message;
        
                    if(errstatus === 401){
        
                        Swal.fire(
                            'Expire Token',
                            'Your Token Has Expire',
                            'warning'
                        ).then(() => {
        
                            localStorage.removeItem("access_token");
        
                            history.push("/login");

                            console.log("2Token Expire 401");
                        });
        
                    }else{
        
                        Swal.fire(
                            'Warning',
                            errmesage,
                            'warning'
                        ).then(() => {
        
                            setSaving(false);
        
                        })
                    }

                });

            } catch (error) {

                Swal.fire(
                    'Warning',
                    error,
                    'warning'
                ).then(() => {

                    setSaving(false);

                })

            }

        }

    };

    useEffect(() => {

        getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="bg-gradient-to-br from-purple-500 to-blue-500 pt-14 pb-28 px-3 md:px-8 h-auto"></div>
            
            <div className="px-3 md:px-8 -mt-24">
                {!listData ? (
                    <div className="flex justify-center items-center" style={{ minHeight: '400px' }}>
                        <ReactLoading
                            type="spinningBubbles"
                            color="rgb(147, 51, 234)"
                            height={100}
                            width={100}
                        />
                    </div>
                ) : (
                    <div className="container mx-auto max-w-full">
                        <Card>
                            <CardHeader color="blueGray" contentPosition="left">
                                <h2 className="text-white text-2xl">AMP Configuration</h2>
                            </CardHeader>

                            <CardBody>
                                {/* Logo Section - Full Width */}
                                <div className="mb-8 pb-8 border-b border-gray-200">
                                    <h6 className="text-purple-600 text-lg font-semibold mb-4 uppercase tracking-wide">
                                        <i className="fas fa-image mr-2"></i>
                                        AMP Website Logo
                                    </h6>
                                    <div className="flex justify-center items-center">
                                        <div className="relative group">
                                            <div className="h-48 w-48 rounded-xl shadow-lg overflow-hidden border-4 border-purple-100 transition-all duration-300 group-hover:border-purple-400 cursor-pointer">
                                                <Image
                                                    src={listData['amp-logo']}
                                                    alt="logo image" 
                                                    onClick={handleChangeImage}
                                                    className="object-contain w-full h-full"
                                                />
                                            </div>
                                            <p className="text-center mt-3 text-sm text-gray-600 group-hover:text-purple-600 transition-colors">
                                                <i className="fas fa-hand-pointer mr-1"></i>
                                                Click image to change
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Two Column Layout */}
                                <div className="grid grid-cols-1 gap-8">
                                    <div className="mt-3 mb-3">
                                        <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                            AMP Login
                                        </h6>
                                        <Input 
                                            color="purple" 
                                            placeholder=" "
                                            defaultValue={listData['amp_link_login']}
                                            onChange={(e) => {
                                                setAmpLogin(e.target.value);
                                            }}
                                        />
                                    </div>

                                    <div className="mt-3 mb-3">
                                        <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                            AMP Register
                                        </h6>
                                        <Input 
                                            color="purple" 
                                            placeholder=" "
                                            defaultValue={listData['amp_link_register']}
                                            onChange={(e) => {
                                                setAmpRegister(e.target.value);
                                            }}
                                        />
                                    </div>

                                    <div className="mt-3 mb-3">
                                        <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                            Link Alternative
                                        </h6>
                                        <Input 
                                            color="purple" 
                                            placeholder=" "
                                            defaultValue={listData['amp_link_alternative']}
                                            onChange={(e) => {
                                                setLinkALternative(e.target.value);
                                            }}
                                        />
                                        <span className="text-gray-500 text-sm">Use comma to seperate, ex:https://google.com,https://facebook.com,https://instagram.com</span>
                                    </div>
                                </div>

                                {/* Save Button at Bottom */}
                                <div className="mt-10 pt-6 border-t border-gray-200 flex justify-end">
                                    <Button
                                        className="h-10
                                            px-5 m-2
                                            text-green-100 
                                            transition-colors 
                                            duration-150 
                                            bg-green-700 
                                            rounded-lg 
                                            focus:shadow-outline 
                                            hover:bg-green-800"
                                        rounded={false}
                                        block={false}
                                        iconOnly={false}
                                        ripple="light"
                                        onClick={() => {
                                            setSaving(true);
                                            handleSave();
                                        }}
                                        disabled={saving}
                                    >
                                        {!saving ? (
                                            <>
                                                <i className="fas fa-save mr-2"></i>
                                                Save All Changes
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-spinner fa-spin mr-2"></i>
                                                Saving...
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                )}
            </div>
        </>

    );

}
